import React, { useMemo } from 'react';
import { regexForStartLinks } from 'appConstants';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IDownloadAppIosUrlField {
	changeDownloadAppIosUrl: (value: string) => void;
	isShowCustomerLoyaltyProgramButtons: boolean;
}

const DownloadAppIosUrlField: React.FC<IDownloadAppIosUrlField> = ({
	changeDownloadAppIosUrl,
	isShowCustomerLoyaltyProgramButtons,
}) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(
		() => [
			() => ({
				validator(_, value) {
					if (value && !value.match(regexForStartLinks)) {
						return Promise.reject(new Error(t('linkMustStartWithHttp')));
					}
					return Promise.resolve();
				},
			}),
		],
		[],
	);

	return (
		<FormInput
			testId="DownloadAppIosUrlField"
			name="downloadAppIosUrl"
			label="downloadAppIosUrlLabel"
			disabled={!isShowCustomerLoyaltyProgramButtons}
			onChange={changeDownloadAppIosUrl}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(DownloadAppIosUrlField);
